import Mousetrap from 'mousetrap';
import 'mousetrap/plugins/global-bind/mousetrap-global-bind';
import { useEffect, useRef } from 'react';

type Key = Parameters<typeof Mousetrap.bind>[0];
type Callback = Parameters<typeof Mousetrap.bind>[1];

type ShortcutOptions = {
  action?: string;
  global?: boolean;
  skip?: boolean;
};

const useShortcut = (
  key: Key,
  callback: Callback,
  { global = false, action, skip = false }: ShortcutOptions = {},
) => {
  const callbackRef = useRef(callback);

  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  const keyJSON = JSON.stringify(key);

  useEffect(() => {
    if (skip) return undefined;

    const parsedKey = JSON.parse(keyJSON);
    Mousetrap[global ? 'bindGlobal' : 'bind'](
      parsedKey,
      (...args) => callbackRef.current(...args),
      action,
    );
    return () => {
      Mousetrap.unbind(parsedKey);
    };
  }, [keyJSON, global, action, skip]);
};

export default useShortcut;
